import { render, staticRenderFns } from "./taskTemplate.vue?vue&type=template&id=0ae0c5c3&scoped=true&"
import script from "./taskTemplate.vue?vue&type=script&lang=js&"
export * from "./taskTemplate.vue?vue&type=script&lang=js&"
import style0 from "./taskTemplate.vue?vue&type=style&index=0&id=0ae0c5c3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae0c5c3",
  null
  
)

export default component.exports